import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { PropsWithChildren } from "react";

interface Props {
    className?: string;
    alignRight?: boolean;
    marginTop?: boolean;
    marginBottom?: boolean;
}

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        "&>*": {
            margin: "0 0.25rem",
            "&:last-child": {
                marginRight: 0
            },
            "&:first-child": {
                marginLeft: 0
            }
        }
    },
    buttonRowAlignRight: {
        marginLeft: "auto"
    },
    buttonRowMarginTop: {
        marginTop: "1rem"
    },
    buttonRowMarginBottom: {
        marginBottom: "1rem"
    }
}));

const QAButtonRow: React.FC<PropsWithChildren<Props>> = props => {
    const classes = useStyles();
    return (
        <div className={
            clsx(classes.root,
                props.alignRight && classes.buttonRowAlignRight,
                props.marginTop && classes.buttonRowMarginTop,
                props.marginBottom && classes.buttonRowMarginBottom,
                props.className)}>
            {props.children}
        </div>
    );
};

export default QAButtonRow;
